import React, { useEffect, useState } from "react";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";
import axios from "axios";
import { handleApiError } from "@utils/errorHandler";
import ClipLoader from "react-spinners/ClipLoader";
import { WarningPopUp, Image } from "hesus-ui-kit";
import { useNavigate } from "react-router-dom";
import { ButtonContainer } from "../../LeadList.styled";
import editIcon from "@icons/ic-green-edit.svg";
import cancelIcon from "@icons/ic-cancel.svg";
import goToIcon from "@icons/ic-goto-page.svg";
import "../../LeadList.scss";

const LeadAction = (props) => {
  const { t, data, updateRefeshStatus } = props;

  const [isLeadValidating, setIsLeadValidating] = useState(false);
  const [isLeadRejecting, setIsLeadRejecting] = useState(false);
  const [isConfirmVisible, setConfirmVisibility] = useState(false);
  const [isConfirm, setActionConfirmStatus] = useState(false);
  const history = useNavigate();

  const redirectToViewPage = () => {
    history(`/lead/view/${data.id}`);
  };

  const onValidateLead = () => {
    setIsLeadValidating(true);
    axios
      .put(`/leads/${data.id}`, { status: 4 })
      .then((response) => {
        updateRefeshStatus();
        setIsLeadValidating(false);
      })
      .catch((error) => handleApiError(error));
  };

  const onPopUpCancel = () => {
    setConfirmVisibility(false);
    setActionConfirmStatus(false);
  };

  const onPopUpConfirm = () => {
    setConfirmVisibility(false);
    setActionConfirmStatus(true);
  };

  const onLeadReject = () => {
    setConfirmVisibility(true);
  };

  useEffect(() => {
    if (isConfirm) {
      setIsLeadRejecting(true);
      axios
        .put(`/leads/${data.id}`, { status: 1 })
        .then((response) => {
          setActionConfirmStatus(false);
          updateRefeshStatus();
          setIsLeadRejecting(false);
        })
        .catch((error) => handleApiError(error));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isConfirm]);

  return (
    <>
      <ButtonContainer>
        <div>
          {[0, 2].indexOf(parseInt(data.status, 10)) !== -1 && (
            <Image
              src={goToIcon}
              title={t("LEADS_PROCESS_ACTION_TOOLTIP")}
              alt={t("LEADS_PROCESS_ACTION_TOOLTIP")}
              className="leads-list__image-icon"
              onClick={redirectToViewPage}
            />
          )}
          {isLeadValidating && <ClipLoader size={15} color="#33a728" />}
          {!isLeadValidating &&
            [2].indexOf(parseInt(data.status, 10)) !== -1 &&
            [4].indexOf(parseInt(data.step, 10)) !== -1 && (
              <Image
                src={editIcon}
                title={t("LEADS_VALIDATE_ACTION_TOOLTIP")}
                onClick={onValidateLead}
                alt={t("LEADS_VALIDATE_ACTION_TOOLTIP")}
                className="leads-list__image-icon"
              />
            )}
          {isLeadRejecting && <ClipLoader size={15} color="#f08046" />}
          {!isLeadRejecting &&
            [(0, 2)].indexOf(parseInt(data.status, 10)) !== -1 && (
              <Image
                src={cancelIcon}
                title={t("LEADS_REJECT_ACTION_TOOLTIP")}
                onClick={onLeadReject}
                alt={t("LEADS_REJECT_ACTION_TOOLTIP")}
                className="leads-list__image-icon"
              />
            )}
        </div>
      </ButtonContainer>
      {isConfirmVisible && (
        <WarningPopUp
          title={t("LEAD_REJECTION_POPUP_TITLE")}
          message={t("LEAD_REJECTION_POPUP_MESSAGE")}
          onPopUpCancel={onPopUpCancel}
          onPopUpConfirm={onPopUpConfirm}
          ValidateContent={t("YES")}
          CancelContent={t("CANCEL")}
        />
      )}
    </>
  );
};

LeadAction.propTypes = {
  data: PropTypes.shape({
    id: PropTypes.number,
    canEdit: PropTypes.number,
  }).isRequired,
  t: PropTypes.func.isRequired,
};
export default withTranslation()(LeadAction);
